// src/config/supabaseClient.ts
import { createClient } from '@supabase/supabase-js';

// Obtén las variables de entorno de Vite (deben empezar con VITE_)
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validación para asegurar que las variables están definidas
if (!supabaseUrl) {
  console.error("Error: VITE_SUPABASE_URL no está definida en el archivo .env");
  throw new Error("Supabase URL no está configurada.");
}
if (!supabaseAnonKey) {
  console.error("Error: VITE_SUPABASE_ANON_KEY no está definida en el archivo .env");
  throw new Error("Supabase Anon Key no está configurada.");
}

// Crea y exporta el cliente Supabase para usarlo en otras partes de la app
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

console.log("Supabase client inicializado."); // Mensaje para depuración inicial